<template>
  <div class="table-responsive">
    <table>
      <thead class="thead-gray">
        <tr class="text-center">
          <th scope="col" class="text-uppercase" v-for="(item, index) in dataHead" :key="index">
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row">
          <td
            v-for="(item, index) in dataRow[0] ? dataRow[0] : []"
            :key="index"
            :class="{ 'text-bold': [0, 4, 5, 6].includes(index) }"
          >
            {{ item }}
          </td>
        </tr>
        <tr class="table-row">
          <td class="text-bold">{{ dataRow[1][0] ? dataRow[1][0] : '' }}</td>
          <td>{{ dataRow[1][1] ? dataRow[1][1] : '' }}</td>
          <td colspan="5" class="text-center">{{ dataRow[1][2] ? dataRow[1][2] : '' }}</td>
        </tr>

        <tr
          class="table-row"
          v-for="(itemRow, index) in dataRow.filter((e, i) => i > 1)"
          :key="index"
        >
          <td
            v-for="(item, indexcol) in itemRow"
            :key="indexcol"
            :class="{ 'text-bold': indexcol === 0 }"
          >
            {{ item }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      dataTable: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dataHead: [],
        dataRow: [],
      }
    },
    mounted() {
      this.dataHead = this.dataTable.column
      this.dataRow = this.dataTable.rows
    },
  }
</script>

<style scoped></style>
